// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__3GgVb","checkboxCol":"Table_checkboxCol__14P62","emailCol":"Table_emailCol__PY4EW","actionCol":"Table_actionCol__2gYr4"};